const routes = [
  {
    path: '/car',
    name: 'Car',
    component: () => import(/* webpackChunkName: "car" */ '@/views/car/CarMain'),
    children: [
      {
        path: 'list',
        alias: '',
        name: 'CarList',
        component: () => import(/* webpackChunkName: "car" */ '@/views/car/CarList'),
        prop: true,
        meta: {
          step: ['차량 설정', '차량 설정 리스트(Car)']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'CarView',
        component: () => import(/* webpackChunkName: "car" */ '@/views/car/CarView'),
        prop: true,
        meta: {
          step: ['차량 설정', '차량 설정 세부(Car)']
        }
      },
      {
        path: 'write',
        name: 'CarWrite',
        component: () => import(/* webpackChunkName: "car" */ '@/views/car/CarView'),
        prop: true,
        meta: {
          step: ['차량 설정', '차량 설정 등록(Car)']
        }
      }
    ]
  }
]

export default routes
